import { apiClient } from "../apiClient";
export const MON_HOC_ENDPOINT = "mon-hoc";
export const monHocApi = {
  SelectAll: () => apiClient.get(`${MON_HOC_ENDPOINT}`),
  /** Cặp môn tương đương đề cương đang có hiệu lực: { id_mon_goc, id_mon_tuong_duong }[] */
  SelectTuongDuongDeCuong: () =>
    apiClient.get(`${MON_HOC_ENDPOINT}/tuong-duong-de-cuong`),
};
